export const ALL_ORGANIZATIONS_OPTION = {
  id: 'null',
  full_name: 'Все организации',
  short_name: 'Все организации',
};
